import { cn } from '../../lib/utils'

export interface DenialComposerProps {
  value: string
  onChange: (next: string) => void
  onCancel: () => void
  onConfirm: () => void
  label?: string
  placeholder?: string
  confirmLabel?: string
}

/**
 * Inline reason composer for deny/dismiss triage actions. Confirm stays
 * disabled until the operator types a non-empty reason.
 */
export function DenialComposer({
  value,
  onChange,
  onCancel,
  onConfirm,
  label = 'Why is this wrong? Your correction trains the agent.',
  placeholder = 'e.g. service was scaled down on purpose; alert threshold is too tight…',
  confirmLabel = 'Confirm deny'
}: DenialComposerProps) {
  const canConfirm = value.trim().length > 0
  return (
    <div className="flex flex-col gap-2 rounded-md border border-st-down/40 bg-st-down-bg/20 p-3">
      <label className="text-11 font-medium uppercase tracking-wide text-st-down">{label}</label>
      <textarea
        autoFocus
        rows={3}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="w-full resize-y rounded-md border border-line bg-bg px-3 py-2 text-sm text-ink placeholder:text-ink-3 focus:border-st-down focus:outline-none focus:ring-2 focus:ring-st-down/30"
      />
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onConfirm}
          disabled={!canConfirm}
          className={cn(
            'inline-flex items-center gap-1 rounded-md border px-2.5 py-1 text-xs font-semibold',
            'transition-[background-color,border-color,opacity] duration-150 ease-out',
            canConfirm
              ? 'cursor-pointer border-st-down bg-st-down text-bg hover:opacity-90'
              : 'cursor-not-allowed border-line bg-bg-sunk text-ink-3'
          )}
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="inline-flex cursor-pointer items-center gap-1 rounded-md border border-line bg-bg px-2.5 py-1 text-xs text-ink-2 hover:bg-bg-sunk"
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
